import { Injectable } from '@angular/core';
import { QueryEntity } from '@examdojo/state';
import { distinctUntilChanged, map } from 'rxjs';
import {
  AssignmentDifficulty,
  AssignmentStudentStoreModel,
  AssignmentStudentUIModel,
} from './assignment-student.model';
import { AssignmentStudentState, AssignmentStudentStore } from './assignment-student.store';

@Injectable({ providedIn: 'root' })
export class AssignmentStudentQuery extends QueryEntity<
  AssignmentStudentState,
  AssignmentStudentStoreModel,
  AssignmentStudentUIModel,
  'student_id'
> {
  constructor(protected override readonly store: AssignmentStudentStore) {
    super(store);
  }

  readonly isEmpty$ = this.entities$.pipe(
    map((entities) => entities.length === 0),
    distinctUntilChanged(),
  );

  override readonly toUIModelFn = (entity: AssignmentStudentStoreModel): AssignmentStudentUIModel => ({
    ...entity,
    studentId: entity.student_id ?? '',
    assignmentId: entity.assignment_id ?? '',
    homeworkActivityId: entity.homework_activity_id ?? null,
    firstName: entity.first_name ?? null,
    lastName: entity.last_name ?? null,
    fullName: [entity.first_name, entity.last_name].filter(Boolean).join(' ') || '',
    profilePic: entity.profile_pic ?? null,
    status: !entity.homework_status
      ? 'NOT_STARTED'
      : entity.homework_status === 'COMPLETED'
        ? 'COMPLETED'
        : 'IN_PROGRESS',
    submittedAt: entity.submitted_at ?? null,
    awardedMarks: entity.awarded_marks ?? null,
    totalMarks: entity.total_marks ?? 0,
    scorePercent:
      entity.awarded_marks !== null && (entity.total_marks ?? 0) > 0
        ? Math.round((entity.awarded_marks / entity.total_marks!) * 100)
        : null,
    keyObservations: entity.key_observations ?? null,
    difficulty: (entity.difficulty as AssignmentDifficulty) ?? null,
  });
}
